<!--商家界面-->
<template>
    <section>
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="filters">
                <el-form-item>
                    <el-input v-model="filters.name" placeholder="商家名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="filters.loginName" placeholder="登录账号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="filters.userId" placeholder="商家ID"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="filters.workerName" placeholder="专属客服名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" v-on:click="getUsers">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleAdd">新增</el-button>
                </el-form-item>
            </el-form>
        </el-col>

        <el-table :data="users" highlight-current-row border stripe v-loading="listLoading"
                  @selection-change="selsChange"
                  style="width: 100%;text-align: center">
            <!--<el-table-column type="index" width="60">
            </el-table-column>-->
            <el-table-column prop="userId" label="商家ID" width="100">
            </el-table-column>
            <el-table-column prop="loginName" label="登录账号" width="130">
            </el-table-column>
            <el-table-column prop="vip" label="VIP" width="90" :formatter="formatVip">
            </el-table-column>
            <el-table-column prop="phone" label="联系方式" width="125">
            </el-table-column>
            <el-table-column prop="techPhone" label="技术支持" width="125">
            </el-table-column>
            <el-table-column prop="name" label="商家名称" width="100">
            </el-table-column>
            <el-table-column prop="money" label="余额" width="100" :formatter="formatMoney">
            </el-table-column>

            <el-table-column prop="workerName" label="专属客服" width="160">
                <template slot-scope="scope">
                    {{scope.row.workerName}}
                    <el-button type="text" size="small" v-if="accountType==0"
                               @click="showUpdateWorkerD(scope.$index, scope.row)"> | 修改
                    </el-button>
                </template>
                <!--<template slot-scope="scope">
                    <el-popover trigger="hover" placement="top">
                        <p>ID: {{ scope.row.workerId }}</p>
                        <p>姓名: {{ scope.row.workerName }}</p>
                        <p>电话: {{ scope.row.workerPhone }}</p>
                        <div slot="reference" class="name-wrapper">
                           <el-tag>专属客服</el-tag>
                        </div>
                    </el-popover>
                </template>-->
            </el-table-column>


            <el-table-column prop="addTime" label="添加时间" width="180">
            </el-table-column>
            <el-table-column label="操作" width="380" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" v-if="scope.row.userType==2" size="small"
                               @click="editMoney(scope.$index, scope.row)">修改余额
                    </el-button>
                    <el-button type="text" size="small" @click="goInstallOrder(scope.$index, scope.row)">
                        查看订单:{{scope.row.orderCount}}
                    </el-button>
                    <el-button type="text" size="small" @click="goProductList(scope.$index, scope.row)">查看产品</el-button>
                    <el-button type="text" size="small" @click="goMoneyLog(scope.$index, scope.row)">余额日志</el-button>
                    <el-button type="text" size="small" @click="edit(scope.$index, scope.row)">编辑</el-button>
                    <el-button type="text" size="small" @click="del(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <!--<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button>-->
            <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="rowCount"
                           :total="total" style="float:right;">
            </el-pagination>
        </el-col>

        <!--编辑界面-->
        <el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
            <el-form :model="editForm" label-width="120px" ref="editForm">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="商家名称">
                            <el-input v-model="editForm.name" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="商家电话">
                            <el-input v-model="editForm.phone" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="技术支持">
                            <el-input v-model="editForm.techPhone" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="VIP用户">
                            <el-select v-model="editForm.vip" placeholder="请选择">
                                <el-option
                                        v-for="item in vip"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="邮箱">
                            <el-input v-model="editForm.email" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="地址">
                            <el-input v-model="editForm.address" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <el-button type="danger" @click.native="resetPsw">密码重置</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
            </div>
        </el-dialog>

        <!--修改余额-->
        <el-dialog title="修改余额" v-model="editMoneyFormVisible" :close-on-click-modal="false" @close="closeDialog">
            <el-form :model="editMoneyForm" label-width="120px" ref="editMoneyForm">
                <el-form-item label="变动金额" class="require">
                    <el-input v-model="editMoneyForm.money" placeholder='例:增加3元,输入:3 减少3元,输入:-3'
                              auto-complete="off"></el-input>
                </el-form-item>

                <el-form-item label="修改原因" class="require">
                    <el-input v-model="editMoneyForm.reason" placeholder='请输入修改原因'
                              auto-complete="off"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editMoneyFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editMoneySubmit">提交</el-button>
            </div>
        </el-dialog>

        <!--新增界面-->
        <el-dialog title="新增" v-model="addFormVisible" :close-on-click-modal="false">
            <el-form :model="addForm" label-width="120px" ref="addForm">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="登录账号" class="require">
                            <el-input v-model="addForm.loginName" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="登录密码" class="require">
                            <el-input type="password" v-model="addForm.password" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="技术支持">
                            <el-input v-model="addForm.techPhone" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="VIP用户">
                            <el-select v-model="addForm.vip" placeholder="请选择">
                                <el-option
                                        v-for="item in vip"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>


                <el-row>
                    <el-col :span="12">
                        <el-form-item label="商家名称" class="require">
                            <el-input v-model="addForm.name" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="商家电话" class="require">
                            <el-input v-model="addForm.phone" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="邮箱">
                            <el-input v-model="addForm.email" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="地址">
                            <el-input v-model="addForm.address" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>


            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
            </div>
        </el-dialog>

        <!--更新专属客服-->
        <el-dialog title="更新专属客服" v-model="updateWorkerFormVisible" :close-on-click-modal="false">
            <el-form :model="updateWorkerForm" label-width="120px" ref="updateWorkerForm">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="选择客服">
                            <el-select style="width:100%" v-model="updateWorkerForm.parentId" placeholder="请选择">
                                <el-option
                                        v-for="item in workers"
                                        :key="item.userId"
                                        :label="item.name"
                                        :value="item.userId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="updateWorkerFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="updateWorkerSubmit">提交</el-button>
            </div>
        </el-dialog>


    </section>
</template>

<script>
    import util from '../../common/js/util'
    import NProgress from 'nprogress'
    import {requestPost} from '../../api/api';
    import {data} from "../../common/data";

    export default {
        data() {
            return {
                accountType: sessionStorage.getItem('type'),
                filters: {
                    userId: '',
                    loginName: '',
                    name: '',
                    workerName: ''
                },
                users: [],
                total: 0,
                rowCount: 20,
                pageNO: 1,
                userType: data.userType,
                vip: data.vip,
                listLoading: false,
                sels: [],

                editFormVisible: false,
                editLoading: false,
                editForm: {
                    userId: '',
                    name: '',
                    phone: '',
                    email: '',
                    address: '',
                    vip: '',
                    techPhone: ''

                },

                addFormVisible: false,
                addLoading: false,
                addForm: {
                    vip: '',
                    userType: 2,
                    loginName: '',
                    password: '',
                    name: '',
                    phone: '',
                    email: '',
                    address: '',
                    techPhone: ''
                },

                editMoneyFormVisible: false,
                editMoneyLoading: false,
                editMoneyForm: {
                    userId: '',
                    money: '',
                    reason: ''
                },
                updateWorkerFormVisible: false,
                updateWorkerForm: {
                    userId: '',
                    parentId: ''
                },
                workers: []


            }
        },
        methods: {

            formatVip: function (row, column) {
                switch (parseInt(row.vip)) {
                    case 0:
                        return '否';
                    case 1:
                        return '是';
                    default:
                        return '否';
                }

            },
            formatMoney: function (row, column) {

                return row.money / 100;
            },

            handleCurrentChange(val) {
                this.pageNO = val;
                this.getUsers();
            },

            closeDialog() {
                this.editMoneyForm = {
                    userId: '',
                    money: '',
                    reason: ''
                }
            },

            getUsers() {
                let para = {
                    rowCount: this.rowCount,
                    pageNO: this.pageNO
                };
                Object.assign(para, this.filters);
                this.listLoading = true;
                NProgress.start();
                let url = 'user/getByUserTypePage.do';
                requestPost(this, url, para).then((res) => {

                    if (res != '') {
                        this.total = res.total;
                        this.users = res.data;
                    }
                    this.listLoading = false;
                    NProgress.done();
                });
            },

            getuserById(id) {
                let para = {userId: id};
                this.listLoading = true;
                NProgress.start();
                let url = 'user/getUserInfo.do';
                requestPost(this, url, para).then((res) => {
                    if (res != '') {
                        this.total = 1;
                        this.users.push(res.data);
                    }
                    this.listLoading = false;
                    NProgress.done();
                });
            },

            //删除
            del: function (index, row) {
                this.$confirm('确认删除该记录吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.listLoading = true;
                    NProgress.start();
                    let para = {userId: row.userId};
                    let url = 'user/del.do';
                    requestPost(this, url, para).then((res) => {
                        this.listLoading = false;
                        NProgress.done();
                        if (res != '') {
                            this.filters.userType = row.userType;
                            util.successTip(this);
                            this.getUsers();
                        }
                    });
                }).catch(() => {

                });
            },

            showUpdateWorkerD(index, row) {
                this.updateWorkerFormVisible = true;
                this.updateWorkerForm.userId = row.userId;
                let para = {
                    userType: 1
                };

                NProgress.start();
                let url = 'user/getByUserType.do';
                requestPost(this, url, para).then((res) => {

                    if (res != '') {

                        this.workers = res.data;
                    }
                    NProgress.done();
                });

            },

            updateWorkerSubmit: function () {

                this.$confirm('确认提交吗？', '提示', {}).then(() => {

                    NProgress.start();
                    let para = Object.assign({}, this.updateWorkerForm);
                    let url = 'user/updateParentId.do';
                    requestPost(this, url, para).then((res) => {

                        NProgress.done();
                        if (res != '') {
                            util.successTip(this);
                            this.$refs['updateWorkerForm'].resetFields();
                            this.updateWorkerFormVisible = false;
                            this.workers = [];
                            this.getUsers();
                        }

                    });
                });

            },

            //显示编辑界面
            edit: function (index, row) {
                this.editFormVisible = true;
                this.editForm = Object.assign({}, row);
            },
            editMoney: function (index, row) {
                this.editMoneyFormVisible = true;
                this.editMoneyForm.userId = row.userId;
            },
            //显示新增界面
            handleAdd: function () {
                this.addFormVisible = true;
            },
            resetPsw: function () {
                this.$confirm('确认重置密码为:123456?', '提示', {
                    type: 'warning'
                }).then(() => {

                    NProgress.start();
                    let para = {userId: this.editForm.userId};
                    let url = 'user/resetPsw.do';
                    requestPost(this, url, para).then((res) => {
                        NProgress.done();
                        if (res != '') {
                            util.successTip(this);
                            this.getUsers();
                        }
                    });
                }).catch(() => {

                });
            },

            editMoneySubmit: function () {
                this.$confirm('确认提交吗？', '提示', {}).then(() => {

                    NProgress.start();
                    let para = Object.assign({}, this.editMoneyForm);
                    para.money = this.editMoneyForm.money * 100;
                    let url = 'user/updateMoney.do';
                    requestPost(this, url, para).then((res) => {
                        NProgress.done();
                        if (res != '') {
                            util.successTip(this);
                            this.$refs['editMoneyForm'].resetFields();
                            this.editMoneyFormVisible = false;
                            this.getUsers();
                        }

                    });
                });
            },

            editSubmit: function () {

                this.$confirm('确认提交吗？', '提示', {}).then(() => {
                    this.editLoading = true;
                    NProgress.start();
                    let para = Object.assign({}, this.editForm);
                    let url = 'user/update.do';
                    requestPost(this, url, para).then((res) => {
                        this.editLoading = false;
                        NProgress.done();
                        if (res != '') {
                            util.successTip(this);
                            this.$refs['editForm'].resetFields();
                            this.editFormVisible = false;
                            this.filters.userType = this.editForm.userType;
                            this.getUsers();
                        }

                    });
                });

            },


            addSubmit: function () {
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            this.addLoading = true;
                            NProgress.start();
                            let para = Object.assign({}, this.addForm);
                            let url = 'user/add.do';
                            //para.birth = (!para.birth || para.birth == '') ? '' : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
                            requestPost(this, url, para).then((res) => {
                                this.addLoading = false;
                                NProgress.done();
                                if (res !== '') {
                                    util.successTip(this);
                                    this.$refs['addForm'].resetFields();
                                    this.addFormVisible = false;
                                    this.filters.userType = this.addForm.userType;
                                    this.getUsers();
                                }
                            });
                        });
                    }
                });
            },

            selsChange: function (sels) {
                this.sels = sels;
            },

            goMoneyLog: function (index, row) {
                this.$router.push({path: '/merchantMoneyLog', query: {userId: row.userId}})
            },
            goInstallOrder(index, row) {
                this.$router.push({path: '/installOrder', query: {userId: row.userId}})
            },
            goProductList(index, row) {
                this.$router.push({path: '/productList', query: {userId: row.userId}})
            }

        },
        activated: function () {

        },
        mounted() {

            let query = this.$route.query;
            if (typeof query.merchantId !== 'undefined') {
                var merchantId = this.$route.query.merchantId;
                this.getuserById(merchantId);
            } else {
                this.filters.userType = 2;
                this.getUsers();
            }
        }
    }

</script>


<style scope lang="scss" type="text/scss">
    @import '../../styles/vars.scss';
</style>


// WEBPACK FOOTER //
// merchant.vue?6e269721